import './pcc.scss';

/* @ngInject */
export default function PCCController($location, NotificationCenterFactory, $rootScope, AccountsFactory) {
    const vm = this;
    const activeNotification = NotificationCenterFactory.getActiveNotification();

    // ActionItemTypeId 23 = Mandatory PCC Notification
    // ActionItemTypeId 24 = Reminder PCC Notification

    vm.hisExempt = null;
    vm.loading = false;

    vm.continueClicked = function () {
        vm.loading = true;
        AccountsFactory.setHISLicenseExemptionStatus({
            ActionItemId: activeNotification.ActionItemId,
            IsHISExempt: vm.hisExempt
        })
        .then(() => {
            vm.loading = false;

            NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);
            if (NotificationCenterFactory.isLastActiveNotification()) {
                vm.closeClicked();
            } else {
                vm.nextClicked();
            }
        });
    };

    vm.nextClicked = function () {
        NotificationCenterFactory.setNextNotificationAsActive();
        $rootScope.$broadcast('notificationCompleted');
    };

    vm.closeClicked = function () {
        $rootScope.$broadcast('closeNotificationModal');
    };

    function updateNotificationStatus(newStatus) {
        NotificationCenterFactory.setActionItemStatus({
            ActionItemId: activeNotification.ActionItemId,
            ActionItemStatus: newStatus
        })
        .then(() => {
            NotificationCenterFactory.markNotificationComplete(activeNotification.ActionItemId);

            if (NotificationCenterFactory.isLastActiveNotification()) {
                vm.closeClicked();
            } else {
                vm.nextClicked();
            }
        })
    }

}



// WEBPACK FOOTER //
// ./src/app/notificationCenter/modal/templates/pcc/pccController.js